import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import BlogService from '../../services/blogService';
import './BlogDetail.css';

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    const fetchBlogDetail = async () => {
      try {
        setLoading(true);
        const data = await BlogService.getBlogByTitle(slug);
        setBlog(data);

        // Fetch more blogs for related posts section
        const relatedData = await BlogService.getAllBlogs(0, 6);
        setRelatedBlogs(relatedData.content?.filter(b => b.id !== data.id) || []);

        setError(null);
      } catch (error) {
        console.error('Error fetching blog detail:', error);
        setError('Failed to load blog post. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchBlogDetail();
    }
  }, [slug]);

  // Function to strip HTML tags
  const stripHtml = (html) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };

  // Function to create a slug from title
  const createSlug = (title) => {
    return title
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  // Function to format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="blog-detail-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading article, please wait...</p>
        </div>
      </div>
    );
  }

  if (error || !blog) {
    return (
      <div className="blog-detail-page">
        <div className="error-container">
          <h3>Article Not Found</h3>
          <p>{error || 'The blog post you are looking for does not exist.'}</p>
          <Link to="/blog" className="back-to-blog-btn">
            ← Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-detail-page">
      {/* Hero Section */}
      <section className="blog-detail-hero">
        <div className="container">
          <div className="blog-breadcrumb">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <Link to="/blog">Blog</Link>
            <span className="separator">/</span>
            <span className="current">{blog.title}</span>
          </div>

          <div className="blog-detail-header">
            {/* <div className="blog-detail-meta">
              <span className="category">Career Advice</span>
              <span className="date">{formatDate(blog.publishedDate)}</span>
              <span className="read-time">5 min read</span>
            </div> */}
            <h1 className="blog-detail-title">{blog.title}</h1>
            {/* <div className="blog-detail-author">
              <span className="author">By HiringOpen</span>
            </div> */}
          </div>
        </div>
      </section>

      {/* Blog Content */}
      <section className="blog-detail-content">
        <div className="container">
          <div className="blog-detail-layout">
            {/* Main Content */}
            <main className="blog-detail-main">
              {blog.coverImageUrl && (
                <div className="blog-detail-image">
                  <img
                    src={blog.coverImageUrl}
                    alt={blog.coverImageAlt || blog.title}
                    className="featured-image"
                  />
                </div>
              )}

              <div className="blog-detail-body">
                <div
                  className="blog-content"
                  dangerouslySetInnerHTML={{ __html: blog.content }}
                />
              </div>

            </main>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogDetail;
